import React, { useState, useEffect, useRef } from 'react'
import styles from './MapPage.module.scss'
import Table from '../../components/TableMen/Table'
import { useGeoState, useGeoFetch } from '../../components/GeoProvider'
import formatAmountINR from '../../utils/convertIntoNumbers'

const VaccineTable = () => {
 const [getVaccineTable, setVaccineTable] = useState()
 const { getRefreshDateFilter, getStateFilter, getAgeGroupFilter, getGenderFilter,
        getVaccineTypeFilter,getMemberTypeFilter } =
        useGeoState()
 const [errorCode, setErrorCode] = useState()
   const [errorMessage, setErrorMessage] = useState()
   const [errorSubject, setErrorSubject] = useState()
   const [errorOccured, seterrorOccured] = useState(false)

  const tableColumns = [
  { id: 1, label: 'Member Type', accessor: 'vaccine_type' },
  { id: 2, label: 'Dose 1', accessor: 'dose1' },
  { id: 3, label: 'Dose 2', accessor: 'dose2' },
  { id: 4, label: 'Dose 2+', accessor: 'dosemorethan2'},
  { id: 5, label: 'Active Member', accessor: 'active_member'},
  { id: 6, label: 'Eligibility Rate %', accessor: 'eligibility_rate'}
]   

  const { data: vaccineTableData, error: VaccineDataError } = useGeoFetch(
    '',
    '',
    'vaccineData',
    'STATE',
    {geo_parent:'US',refresh_date:getRefreshDateFilter,state:getStateFilter,gender:getGenderFilter,age_group:getAgeGroupFilter,vaccine_type:getVaccineTypeFilter,module_name:'SHINGLES',member_type:getMemberTypeFilter},
    'POST'
  )

  useEffect(() => {
    if (vaccineTableData !== null && vaccineTableData !== undefined) {
      if (vaccineTableData.response_code === 200) {
        setVaccineTable(vaccineTableData.response_data)
      } else {
        setErrorCode(vaccineTableData.response_code)
        setErrorMessage(vaccineTableData.response_message)
        setErrorSubject(vaccineTableData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [vaccineTableData])

  const numericFields = ['dose1', 'dose2', 'dosemorethan2', 'active_member'];
let formattedTable = [];

if (getVaccineTable && Array.isArray(getVaccineTable)) {
  formattedTable = getVaccineTable.map(item => {
    const updated = { ...item };
    for (const key of numericFields) {
      if (key in updated) {
        updated[key] = formatAmountINR(updated[key]);
      }
    }
    // Decide what you want for eligibility_rate (keep as-is or format differently)
    // updated.eligibility_rate = `${Number(item.eligibility_rate)}%`; // optional
    return updated;
  });
}

    return (
  <>
    {Array.isArray(getVaccineTable) ? (
      <div style={{borderRadius:"4px", border:"1.5px solid #cbcccd", display:"block" }} className={styles.base}>
        <div style={{padding:"10px"}}>
           <span className={styles.captionFormat}>
            
             Member Table
           </span>
         </div>
        <div style={{padding:"10px"}} className={styles.maindivFormat}>         
          {getVaccineTable.length === 0 ?
           <div style={{ display: 'flex' }} >No data available for the selected filters</div>:
           <Table cols={tableColumns} rows={formattedTable} />}
        </div>
      </div>
    ) : null}
  </>
);

}

export default VaccineTable